// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Shareholder } from './shareholder';
import { ShareholderClass } from './shareholder-class';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Shareholding extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  shareholdingId!: number;
  createdBy!: string;
  createdDate!: Date;
  dividendShares!: number;
  noOfShares!: number;
  nominalValue!: number;
  paidUpValue!: number;
  shareholderClassId!: number;
  shareholderId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  shareholder!: Shareholder;
  shareholderClass!: ShareholderClass;
}

